:host 
  display: block

.accordian-content
  overflow: hidden
  position: relative
  transition: 0.8s ease-in-out

  .gradient-overlay
    display: block
    width: 100%
    position: absolute
    bottom: 0
    left: 0
    transition: 0.8s ease-in-out
